let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hyqsV"), load("fhU7k")]).then(() => parcelRequire('cJyjM'));